import { Editor } from "primereact/editor";

export const CustomEditor = ({ label, name, onTextChange, data, value, errorMessage, extraClassName, required, col, inputClass, ...props }) => {
    return (
        <>
            <Editor
                value={value}
                id={name}
                name={name}
                onTextChange={onTextChange}
                className={`w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""}`}
                placeholder={props.placeholder || `${label}`}
                {...props}
                style={{ height: "320px" }}
            />
            {errorMessage ? <small className="p-error">{errorMessage}</small> : null}
        </>
    );
};
